import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Chip,
    Box,
    Typography,
    Tooltip,
    TableSortLabel
} from '@mui/material';
import {
    Edit as EditIcon,
    Delete as DeleteIcon
} from '@mui/icons-material';

const MenuTable = ({ menus, onEdit, onDelete, onSort, sortBy, sortOrder, loading }) => {
    const renderPermissions = (permissions) => {
        if (!permissions || permissions.length === 0) {
            return (
                <Typography variant="body2" color="text.secondary">
                    No permissions
                </Typography>
            );
        }

        return (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {permissions.slice(0, 2).map((permission, index) => (
                    <Chip
                        key={index}
                        label={permission.name}
                        size="small"
                        variant="outlined"
                        color="primary"
                    />
                ))}
                {permissions.length > 2 && (
                    <Tooltip
                        title={
                            <Box>
                                {permissions.slice(2).map((p, i) => (
                                    <div key={i}>{p.name}</div>
                                ))}
                            </Box>
                        }
                    >
                        <Chip
                            label={`+${permissions.length - 2} more`}
                            size="small"
                            variant="filled"
                            color="secondary"
                        />
                    </Tooltip>
                )}
            </Box>
        );
    };

    const createSortHandler = (property) => () => {
        onSort(property);
    };

    return (
        <TableContainer>
            <Table sx={{ minWidth: 650 }}>
                <TableHead>
                    <TableRow>
                        <TableCell>
                            <TableSortLabel
                                active={sortBy === 'menuId'}
                                direction={sortBy === 'menuId' ? sortOrder : 'asc'}
                                onClick={createSortHandler('menuId')}
                            >
                                Menu ID
                            </TableSortLabel>
                        </TableCell>
                        <TableCell>
                            <TableSortLabel
                                active={sortBy === 'name'}
                                direction={sortBy === 'name' ? sortOrder : 'asc'}
                                onClick={createSortHandler('name')}
                            >
                                Name
                            </TableSortLabel>
                        </TableCell>
                        <TableCell>
                            <TableSortLabel
                                active={sortBy === 'code'}
                                direction={sortBy === 'code' ? sortOrder : 'asc'}
                                onClick={createSortHandler('code')}
                            >
                                Code
                            </TableSortLabel>
                        </TableCell>
                        <TableCell>
                            <TableSortLabel
                                active={sortBy === 'parentId'}
                                direction={sortBy === 'parentId' ? sortOrder : 'asc'}
                                onClick={createSortHandler('parentId')}
                            >
                                Parent ID
                            </TableSortLabel>
                        </TableCell>
                        <TableCell>
                            <TableSortLabel
                                active={sortBy === 'groupId'}
                                direction={sortBy === 'groupId' ? sortOrder : 'asc'}
                                onClick={createSortHandler('groupId')}
                            >
                                Group ID
                            </TableSortLabel>
                        </TableCell>
                        <TableCell>
                            <TableSortLabel
                                active={sortBy === 'serial'}
                                direction={sortBy === 'serial' ? sortOrder : 'asc'}
                                onClick={createSortHandler('serial')}
                            >
                                Serial
                            </TableSortLabel>
                        </TableCell>
                        <TableCell>Permissions</TableCell>
                        <TableCell align="center">Actions</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {menus.length === 0 ? (
                        <TableRow>
                            <TableCell colSpan={8} align="center">
                                <Typography variant="body1" color="text.secondary" sx={{ py: 4 }}>
                                    No menus found
                                </Typography>
                            </TableCell>
                        </TableRow>
                    ) : (
                        menus.map((menu) => (
                            <TableRow
                                key={menu.id || menu.menuId}
                                hover
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell>
                                    <Typography variant="body2" fontWeight="medium">
                                        {menu.menuId}
                                    </Typography>
                                </TableCell>
                                <TableCell>{menu.name}</TableCell>
                                <TableCell>
                                    <Chip label={menu.code} size="small" />
                                </TableCell>
                                <TableCell>{menu.parentId}</TableCell>
                                <TableCell>{menu.groupId}</TableCell>
                                <TableCell>{menu.serial}</TableCell>
                                <TableCell sx={{ maxWidth: 300 }}>
                                    {renderPermissions(menu.permissions)}
                                </TableCell>
                                <TableCell align="center">
                                    <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                                        <Tooltip title="Edit">
                                            <IconButton
                                                color="primary"
                                                size="small"
                                                onClick={() => onEdit(menu)}
                                            >
                                                <EditIcon />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Delete">
                                            <IconButton
                                                color="error"
                                                size="small"
                                                onClick={() => onDelete(menu.menuId)}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                </TableCell>
                            </TableRow>
                        ))
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default MenuTable;
